<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>Remembering Farley</title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<p class="textD">Contents</p>
<p class="text"><a href="#/mom005">Introduction</a></p>
<p class="text"><a href="#/mom011">The Psychic</a></p>
<p class="text"><span href="#/mom043" title="Link target outside of Sample">The Clipper</span></p>
<p class="text"><span href="#/mom053" title="Link target outside of Sample">The Genius</span></p>
<p class="text"><span href="#/mom079" title="Link target outside of Sample">The Dreamer</span></p>
<p class="text"><span href="#/mom115" title="Link target outside of Sample">The Body Double</span></p>
<p class="text"><span href="#/mom137" title="Link target outside of Sample">The Spark</span></p>
<p class="text"><span href="#/mom171" title="Link target outside of Sample">The Action Figure</span></p>
<p class="text"><span href="#/mom185" title="Link target outside of Sample">The Mother of the Potential Bride</span></p>
<p class="text"><span href="#/mom241" title="Link target outside of Sample">The Miracle Worker</span></p>
<p class="text"><span href="#/mom259" title="Link target outside of Sample">The Clone</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mom004.vue?218bc214